import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateLayoutDocument } from './create.generated';

export const useCreateLayout = (options: ApiOptions<typeof CreateLayoutDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateLayoutDocument, {
    ...useNotifications(CreateLayoutDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.layouts.create_success'),
    }),

    ...options,
  });
};
